import { useParams } from 'react-router-dom';
import AddGeodata from './AddGeodata';

const GeodataReview = () => {
  const { geodataId } = useParams();

  return <AddGeodata reviewMode reviewGeodataId={geodataId} />;
};

export default GeodataReview;
